import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { config } from '../../shared/config';
import { map, tap } from 'rxjs/operators';
import { ZoneSubscription } from '../models/zone-subscription';
import { ChangeStateModel } from '../models/change-state-model';
import { BaseHttpService } from '../../core/services/base-http.service';
import { StorageService } from '../../core/storage/storage.service';
import { ZoneUnitsSubscription } from '../models/zone-units-subscription';

@Injectable({
  providedIn: 'root'
})
export class ZoneSubscriptionsService extends BaseHttpService {

  constructor(
    protected _http: HttpClient,
    protected _storage: StorageService,
  ) {
    super(_http, _storage);
  }

  getZones(): Observable<ZoneSubscription[]> {
    return this.get(config.generateApiUrl(`zones/subscriptions`, null, null, '2.2')).pipe(
      map((stat) => stat['data']['items'] as ZoneSubscription[]),
      tap((zones: ZoneSubscription[]) => zones.forEach(zone => zone.visible = true))
    );
  }

  createZone(data: ZoneSubscription): Observable<ZoneSubscription> {
    return this._http.post(config.generateApiUrl(`zones/subscriptions`, null, null, '2.2'), data).pipe(
      map((stat) => stat['data']['item'] as ZoneSubscription),
      tap((zone: ZoneSubscription) => zone.visible = true)
    );
  }

  editZone(data: ZoneSubscription): Observable<ZoneSubscription> {
    return this._http.put(config.generateApiUrl(`zones/subscriptions`, null, null, '2.2'), data).pipe(
      map((stat) => stat['data']['item'] as ZoneSubscription),
      tap((zone: ZoneSubscription) => zone.visible = true)
    );
  }

  editUnitsZone(data: ZoneUnitsSubscription): Observable<ZoneUnitsSubscription> {
    return this._http.put(config.generateApiUrl(`zones/subscriptions/units`, null, null, '2.2'), data).pipe(
      map((stat) => stat['data'] as ZoneUnitsSubscription),
    );
  }

  changeState(data: ChangeStateModel): Observable<ChangeStateModel> {
    return this._http.put(config.generateApiUrl(`zones/subscriptions/changeState`, null, null, '2.2'), data).pipe(
      map((stat) => stat['data']['item'] as ChangeStateModel)
    );
  }

  deleteZone(zoneId: number): Observable<number> {
    return this._http.delete(config.generateApiUrl(`zones/subscriptions/${zoneId}`, null, null, '2.2')).pipe(
      map((stat) => stat['data']['item'])
    )
  }
}
